import React from 'react';
import PropTypes from 'prop-types';

import Link from '@marvelapp/marvel-ui/link';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import ArrowRight from 'marketing-website/components/icons/ArrowRight';

import styles from './style/general.module.css';

export default function ArrowLink({ children, colour, size, weight }) {
  return (
    <div className={colour === 'blue' ? styles.marvelFill : styles.blackFill}>
      <Link type={colour}>
        <Heading size={size} weight={weight}>
          <Link type={colour}>
            <InlineGrid size="xs">
              {children}
              <ArrowRight />
            </InlineGrid>
          </Link>
        </Heading>
      </Link>
    </div>
  );
}

ArrowLink.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['s', 'm', 'l']),
  colour: PropTypes.oneOf(['blue', 'black']),
  weight: PropTypes.oneOf(['semibold', 'bold', 'regular']),
};

ArrowLink.defaultProps = {
  colour: 'blue',
  size: 'm',
  weight: 'regular',
  color: 'marvel',
};



// WEBPACK FOOTER //
// ./src/components/commons/ArrowLink/index.js